import { makeVar, useReactiveVar } from "@apollo/client";
import { HydrationHelper } from "core/utils";
import { Status } from "@jawbreaker/auth-status";
export var stateVar = makeVar({ kind: "Pending" });
export var marketingConsentVar = makeVar(false);
export var useStatus = function () {
    var state = useReactiveVar(stateVar);
    return HydrationHelper.useComplete() ? state : Status.pending();
};
